export const NO_ACTIVE_SLATE = "No active DraftKings slate is currently available.";

export function canonicalToDraftKingsContract(canonical) {
  if (!canonical || canonical.sport !== "NFL" || !["CLASSIC", "SHOWDOWN"].includes(canonical.contestType)) throw new Error("Active DraftKings slate contract is invalid.");
  const players = (canonical.players || []).map((player) => ({
    id: String(player.draftKingsId),
    nameId: player.draftKingsNameId,
    name: player.name,
    position: player.position,
    rosterPositions: player.eligibleRosterPositions,
    salary: player.salary,
    gameInfo: player.gameInfo,
    team: player.team,
    avgPoints: player.averageFantasyPoints,
  }));
  return {
    fileName: canonical.sourceFilename,
    contestType: canonical.contestType,
    lineupHeader: canonical.rosterSlots,
    rawLineupHeader: canonical.rosterSlots,
    salaryCap: canonical.salaryCap,
    players,
    errors: [],
    teams: [...new Set(players.map((player) => player.team).filter(Boolean))].sort(),
    games: canonical.games || [],
    positions: [...new Set(players.map((player) => player.position).filter(Boolean))].sort(),
    slateId: canonical.slateId,
    version: canonical.version,
    slateName: canonical.slateName,
    source: "THEO_ACTIVE",
  };
}

const LOCAL_PREVIEW_BUILD = process.env.REACT_APP_PWG_PRODUCTION_RELEASE !== "1";
const LOCAL_DRAFTKINGS_BASE = LOCAL_PREVIEW_BUILD ? "http://localhost:5050" : "";

export async function fetchActiveDraftKingsSlates(contestType, fetchImpl = fetch, apiBase = LOCAL_DRAFTKINGS_BASE) {
  const response = await fetchImpl(`${apiBase}/api/draftkings/slates/active/${contestType}`, { credentials: "omit", cache: "no-store" });
  const payload = await response.json();
  if (response.status === 404) return [];
  if (!response.ok) throw new Error(payload.error || "Unable to load active DraftKings slates.");
  return (payload.slates || []).map((entry) => ({ ...entry, contract: canonicalToDraftKingsContract(entry.canonical) }));
}
